export default function(objToDeleteVar = 'objToDelete')
{
    return {
        get() { return Boolean(this[objToDeleteVar]); },
        set(val) { this[objToDeleteVar] = val ? val : null; }
    }
}